import script from "./dispose-timeline.vue?vue&type=script&setup=true&lang=ts"
export * from "./dispose-timeline.vue?vue&type=script&setup=true&lang=ts"

import "./dispose-timeline.vue?vue&type=style&index=0&id=6c543565&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c543565"]])

export default __exports__